var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgType3A(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f1f5ff;stroke:#353841;stroke-width:1.5px;}.b{fill:#cad0e4;}.c,.e{fill:#353841;}.d,.h{fill:#71778a;}.f,.h{stroke:none;}.g{fill:none;}.i{filter:url(#g);}.j{filter:url(#e);}.k{filter:url(#c);}.l{filter:url(#a);}"), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 39,
    y: 29.031,
    width: 16,
    height: 16,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "c",
    x: 30.102,
    y: 19.102,
    width: 13.797,
    height: 13.797,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "d"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "d"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "e",
    x: 29,
    y: 40,
    width: 16,
    height: 16,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "f"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "f"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "g",
    x: 19,
    y: 29.031,
    width: 16,
    height: 16,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "h"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "h"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 74,
    height: 74,
    rx: 12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "g",
    x: 0.75,
    y: 0.75,
    width: 72.5,
    height: 72.5,
    rx: 11.25
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.002 15.999)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-16476,2854a20.877,20.877,0,0,1-14.854-6.15,21.027,21.027,0,0,1-4.148-5.881v-17.938a21.049,21.049,0,0,1,4.148-5.881A20.876,20.876,0,0,1-16476,2812a20.885,20.885,0,0,1,11.381,3.355,21.028,21.028,0,0,1,7.617,8.689v17.913a21.063,21.063,0,0,1-7.617,8.693A20.913,20.913,0,0,1-16476,2854Z",
    transform: "translate(16494.998 -2812)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "l",
    transform: "matrix(1, 0, 0, 1, -18, -16)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "translate(42 32.03)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M 5 9 C 2.794389963150024 9 1 7.205609798431396 1 5 C 1 2.794389963150024 2.794389963150024 1 5 1 C 7.205609798431396 1 9 2.794389963150024 9 5 C 9 7.205609798431396 7.205609798431396 9 5 9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M 5 2 C 3.345789909362793 2 2 3.345789909362793 2 5 C 2 6.654210090637207 3.345789909362793 8 5 8 C 6.654210090637207 8 8 6.654210090637207 8 5 C 8 3.345789909362793 6.654210090637207 2 5 2 M 5 0 C 7.761420249938965 0 10 2.238580226898193 10 5 C 10 7.761420249938965 7.761420249938965 10 5 10 C 2.238580226898193 10 0 7.761420249938965 0 5 C 0 2.238580226898193 2.238580226898193 0 5 0 Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "k",
    transform: "matrix(1, 0, 0, 1, -18, -16)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "translate(33.1 22.1)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M 3.8984375 6.796877384185791 C 2.300227403640747 6.796877384185791 0.9999974966049194 5.496647357940674 0.9999974966049194 3.8984375 C 0.9999974966049194 2.300227403640747 2.300227403640747 0.9999974966049194 3.8984375 0.9999974966049194 C 5.496647357940674 0.9999974966049194 6.796877384185791 2.300227403640747 6.796877384185791 3.8984375 C 6.796877384185791 5.496647357940674 5.496647357940674 6.796877384185791 3.8984375 6.796877384185791 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M 3.8984375 1.999997615814209 C 2.851637363433838 1.999997615814209 1.999997615814209 2.851637363433838 1.999997615814209 3.8984375 C 1.999997615814209 4.945237159729004 2.851637363433838 5.796877384185791 3.8984375 5.796877384185791 C 4.945237159729004 5.796877384185791 5.796877384185791 4.945237159729004 5.796877384185791 3.8984375 C 5.796877384185791 2.851637363433838 4.945237159729004 1.999997615814209 3.8984375 1.999997615814209 M 3.8984375 -2.384185791015625e-06 C 6.051487445831299 -2.384185791015625e-06 7.796877384185791 1.745387554168701 7.796877384185791 3.8984375 C 7.796877384185791 6.051487445831299 6.051487445831299 7.796877384185791 3.8984375 7.796877384185791 C 1.745387554168701 7.796877384185791 -2.384185791015625e-06 6.051487445831299 -2.384185791015625e-06 3.8984375 C -2.384185791015625e-06 1.745387554168701 1.745387554168701 -2.384185791015625e-06 3.8984375 -2.384185791015625e-06 Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "j",
    transform: "matrix(1, 0, 0, 1, -18, -16)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M5,0A5,5,0,1,1,0,5,5,5,0,0,1,5,0Z",
    transform: "translate(32 43)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "i",
    transform: "matrix(1, 0, 0, 1, -18, -16)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "translate(22 32.03)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M 5 9 C 2.794389963150024 9 1 7.205609798431396 1 5 C 1 2.794389963150024 2.794389963150024 1 5 1 C 7.205609798431396 1 9 2.794389963150024 9 5 C 9 7.205609798431396 7.205609798431396 9 5 9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M 5 2 C 3.345789909362793 2 2 3.345789909362793 2 5 C 2 6.654210090637207 3.345789909362793 8 5 8 C 6.654210090637207 8 8 6.654210090637207 8 5 C 8 3.345789909362793 6.654210090637207 2 5 2 M 5 0 C 7.761420249938965 0 10 2.238580226898193 10 5 C 10 7.761420249938965 7.761420249938965 10 5 10 C 2.238580226898193 10 0 7.761420249938965 0 5 C 0 2.238580226898193 2.238580226898193 0 5 0 Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M1.551,0A1.551,1.551,0,1,1,0,1.551,1.551,1.551,0,0,1,1.551,0Z",
    transform: "translate(17.447 30.45)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgType3A);
export default __webpack_public_path__ + "static/media/type3a.1f7f41e7ad76188f679b8f18c4daf92f.svg";
export { ForwardRef as ReactComponent };